import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import type { Tree, FlattenedTree, TreeOptions } from './types'
import cloneDeep from 'lodash/cloneDeep'

export function flattenTree<T extends Tree>(root: T, options?: TreeOptions): FlattenedTree<T>[] {
  const result: FlattenedTree<T>[] = []
  const childrenKey = options?.childrenName ?? 'items'
  const startsFromRoot = options?.startsFromRoot ?? true
  const clonedRoot = cloneDeep(root)

  function walk(node: T, parentId: string | null, depth: number, path: string[]) {
    const children = get(node, childrenKey, []) as T[]
    const currentPath = [...path, node._id]
    const hasChildren = Array.isArray(children) && !isEmpty(children)

    // Copy node but exclude the children
    const { [childrenKey]: _, ...rest } = node as any

    if (startsFromRoot || depth > 0) {
      result.push({
        ...rest,
        _parentId: parentId,
        _depth: depth,
        _path: currentPath,
        _hasChildren: hasChildren,
      })
    }

    for (const child of children) {
      walk(child, node._id, depth + 1, currentPath)
    }
  }

  if (clonedRoot) {
    walk(clonedRoot, null, 0, [])
  }

  return result
}
